import React from 'react';
import { Container } from './toast-container.styles';
var ToastContainer = function (_a) {
    var children = _a.children, placement = _a.placement;
    return (React.createElement(Container, { placement: placement }, children));
};
export default ToastContainer;
